// FE:C7 — help entries for the Views surface (namespace `views`, CONTRACTS §6).
// Every claim names the code that makes it true.
import type { HelpEntry } from '../types'

export const HELP: readonly HelpEntry[] = [
  {
    id: 'views.describe',
    title: 'Describe a view',
    body: 'Type what you want to see, for example “Revenue by account, last 6 months, only P&L”. FuseGrid picks the dataset, measures, dimensions and members from the governed catalog, reads the period itself, and fills the builder so you can see and change every choice. If a word could mean more than one thing, it asks you to pick.',
    verified_by: ['fusegrid_v2/server/src/platform/views/describe.rs:321', 'fusegrid_v2/server/src/platform/views/period.rs:87'],
  },
  {
    id: 'views.builder',
    title: 'Build a view by hand',
    body: 'Choose a dataset, grain, measures (including ratios and differences), dimensions, filters, a pivot, a sort and a top-N. After every change FuseGrid repeats the whole view back in plain words.',
    verified_by: ['fusegrid_v2/server/src/platform/views/summary.rs:45', 'fusegrid_v2/src/components/views/MemberPicker.tsx:17'],
  },
  {
    id: 'views.limits',
    title: 'Size limits',
    body: 'A view can have up to 2,000,000 rows, 250 MB of output, 240 periods and 250 filter members. FuseGrid refuses a view over these limits before it runs.',
    verified_by: ['fusegrid_v2/server/src/platform/views/spec.rs:53'],
  },
  {
    id: 'views.period',
    title: 'Following FG_Period',
    body: 'A view can follow the workbook’s FG_Period control (the last N months ending at the as-of month) or use fixed dates. Views that follow FG_Period move forward when you roll the workbook forward and refresh.',
    verified_by: ['fusegrid_v2/server/src/platform/views/period.rs:22', 'fusegrid_v2/server/src/platform/views/routes.rs:526'],
  },
  {
    id: 'views.excel',
    title: 'Put a view in Excel',
    body: 'Link a saved view as a refreshable table (up to 1,000,000 rows) or as FUSEGRID formulas for anything larger. Put in Excel queues the change; you approve it in the FuseGrid pane.',
    verified_by: ['fusegrid_v2/server/src/platform/views/spec.rs:128', 'fusegrid_v2/public/excel-addin/host-operations/view-link.js:34', 'fusegrid_v2/src/components/views/viewsApi.ts:91'],
  },
  {
    id: 'views.formulas',
    title: 'FUSEGRID formulas',
    body: '=FUSEGRID.VALUE(FGV_MY_VIEW, "Revenue", "Account", "Services", FG_Period) returns one governed number, calculated by FuseGrid to the cent. =FUSEGRID.TABLE(FGV_MY_VIEW, 100) spills rows; =FUSEGRID.REFRESHED(FGV_MY_VIEW) shows when the data was refreshed. Refer to the view’s FGV_ name so the formulas recalculate when the view refreshes. Rarely, when two views’ names differ only in punctuation, the second gets a short code on the end (FGV_MY_VIEW_1a2b3c4d); use the name FuseGrid places in the sheet.',
    verified_by: ['fusegrid_v2/public/excel-addin/functions/functions.js:111', 'fusegrid_v2/public/excel-addin/functions/functions.js:40', 'fusegrid_v2/server/src/platform/views/lookup.rs:188'],
  },
  {
    id: 'views.plan_formula',
    title: 'The governed plan in your own sheets',
    body: '=FUSEGRID.PLAN("Revenue", FG_Period, FGP_BUDGET) returns the published budget for that line and month; use FGP_FORECAST for the forecast. The line is its label or node id. FGP_BUDGET and FGP_FORECAST hold the plan’s version, so the formulas recalculate when a new version is published or undone, and a line or month the plan does not have shows an error rather than zero. Each PLAN cell FuseGrid places carries a plain-Excel fallback into the workbook’s plan table, so it still shows values without the add-in.',
    verified_by: ['fusegrid_v2/public/excel-addin/functions/functions.js:269', 'fusegrid_v2/public/excel-addin/functions/functions.js:33', 'fusegrid_v2/public/excel-addin/plan-formula.js:189'],
  },
  {
    id: 'views.refresh',
    title: 'Refresh and receipts',
    body: 'Refresh recalculates the view from the latest published books and records a receipt: the source fingerprint, the row count and the time. Linked formulas and tables update from the new version.',
    verified_by: ['fusegrid_v2/server/src/platform/views/store.rs:90', 'fusegrid_v2/public/excel-addin/host-operations/view-link.js:143'],
  },
  {
    id: 'views.save',
    title: 'Save personal or publish',
    body: 'Save a view for yourself, or publish it to the workspace so everyone on the company can use it. Publishing needs the owner role.',
    verified_by: ['fusegrid_v2/src/components/views/viewsApi.ts:84', 'fusegrid_v2/server/src/platform/views/routes.rs:399'],
  },
]
